import React from "react";

import { useCart }
from "../components/CartContext";

import {
  useNavigate,
} from "react-router-dom";

import "../styles/CartPage.css";

const CartPage = () => {

  const {

    cart,

    removeFromCart,

    clearCart,

    incrementQuantity,

    decrementQuantity,

    cartSubtotal,

    tax,

    shipping,

    cartTotal,

  } = useCart();

  const navigate =
    useNavigate();

  /* =====================================================
  EMPTY CART
  ===================================================== */

  if (cart.length === 0)

    return (

      <div className="sacEmptyCart">

        <h2>

          Your cart is empty 🛒

        </h2>

        <p>

          Looks like you haven’t
          added anything yet.

        </p>

        <button
          className="sacContinueBtn"

          onClick={() =>
            navigate("/products")
          }
        >

          Shop Now

        </button>

      </div>
    );

  return (

    <div className="sacCartPage">

      {/* TITLE */}

      <h1 className="sacCartTitle">

        Shopping Cart

      </h1>

      <div className="sacCartWrapper">

        {/* =====================================================
        LEFT SIDE
        ===================================================== */}

        <div className="sacCartItems">

          {cart.map((item) => {

            const price =

              item.discountPrice ||

              item.price;

            return (

              <div
               key={`${item._id}-${item.variant}`}

                className="sacCartItem"
              >

                {/* IMAGE */}

                <div className="sacCartImage">

                  <img
                    src={
                      item.imageUrls?.[0] ||

                      item.image ||

                      "/placeholder.png"
                    }

                    alt={item.name}

                    onError={(e) =>
                      (e.target.src =
                        "/placeholder.png")
                    }
                  />

                </div>

                {/* INFO */}

                <div className="sacCartContent">

                  <h2>

                    {

                      item.name?.length > 90

                      ? item.name.slice(0,90) + "..."

                      : item.name
                    }

                  </h2>

                  {/* PRICE */}

                  <div className="sacCartPrice">

                    ₹
                    {price.toLocaleString()}

                  </div>

                  {/* QTY */}

                  <div className="sacQtyRow">

                    <button
                      className="sacQtyBtn"

                      onClick={() =>
  decrementQuantity(
    item._id,
    item.variant
  )
}
                    >

                      -

                    </button>

                    <span className="sacQtyNumber">

                      {item.quantity}

                    </span>

                    <button
                      className="sacQtyBtn"

                      onClick={() =>
  incrementQuantity(
    item._id,
    item.variant
  )
}
                    >

                      +

                    </button>

                  </div>

                  {/* SUBTOTAL */}

                  <div className="sacItemSubtotal">

                    Subtotal:
                    {" "}
                    ₹
                    {(
                      price *
                      item.quantity
                    ).toLocaleString()}

                  </div>

                  {/* REMOVE */}

                  <button
                    className="sacRemoveBtn"

                   onClick={() =>
  removeFromCart(
    item._id,
    item.variant
  )
}
                  >

                    Remove

                  </button>

                </div>

              </div>
            );
          })}

        </div>

        {/* =====================================================
        RIGHT SIDE
        ===================================================== */}

        <div className="sacSummary">

          <h2>

            Order Summary

          </h2>

          <div className="sacSummaryRow">

            <span>

              Total Items

            </span>

            <span>

              {cart.reduce(

                (sum, item) =>

                  sum +
                  item.quantity,

                0
              )}

            </span>

          </div>

          <div className="sacSummaryRow">

            <span>

              Subtotal

            </span>

            <span>

              ₹
              {cartSubtotal.toLocaleString()}

            </span>

          </div>

          <div className="sacSummaryRow">

            <span>

              GST (18%)

            </span>

            <span>

              ₹
              {tax.toLocaleString()}

            </span>

          </div>

          <div className="sacSummaryRow">

            <span>

              Shipping

            </span>

            <span>

              ₹
              {shipping.toLocaleString()}

            </span>

          </div>

          <div className="sacGrandTotal sacSummaryRow">

            <span>

              Grand Total

            </span>

            <span>

              ₹
              {cartTotal.toLocaleString()}

            </span>

          </div>

          {/* FREE SHIPPING */}

          {cartTotal < 5000 && (

            <p
              style={{

                color:"#9dff00",

                marginTop:"14px",

                fontSize:"14px",
              }}
            >

              Add ₹
              {(5000 - cartTotal)
                .toLocaleString()}

              {" "}more for FREE delivery 🚚

            </p>
          )}

          {/* =====================================================
          BUTTONS
          ===================================================== */}

          <button
            className="sacCheckoutBtn"

            onClick={() => {

              /* META PIXEL */

              if (window.fbq) {

                window.fbq(
                  "track",
                  "InitiateCheckout",

                  {

                    value:cartTotal,

                    currency:"INR",

                    num_items:
                      cart.reduce(

                        (sum, item) =>

                          sum +
                          item.quantity,

                        0
                      ),

                    content_ids:
                      cart.map(
                        item =>
                        item._id
                      ),

                    content_type:
                      "product",
                  }
                );
              }

              navigate("/checkout");
            }}
          >

            Proceed to Checkout

          </button>

          {/* CLEAR */}

          <button
            className="sacClearBtn"

            onClick={() => {

              if (
                window.confirm(
                  "Clear cart?"
                )
              ) {

                clearCart();
              }
            }}
          >

            Clear Cart

          </button>

          {/* CONTINUE */}

          <button
            className="sacContinueBtn"

            onClick={() =>
              navigate("/products")
            }
          >

            Continue Shopping

          </button>

        </div>

      </div>

    </div>
  );
};

export default CartPage;